/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FontColor4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class FontColor4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.FontColor4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.FontColor4STBehavior.prototype */ {
      __name: "FontColor4STBehavior",

      usedStyleAttributes: ["textColor"],

      _watchThemeChanged: true,

      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        if (widget?.setFontSize) {
          const font = controller.getAnchorNode().getStyleAttribute("textColor");
          widget.setFontColor(context.ThemeService.resolveThemedColor(font));
        }
      }
    };
  });
});
